import moment from 'moment'
import pick from 'lodash/pick'

export const downloadFile = (
  reportType: string,
  data: any,
  filter: any,
  totalCount?: number,
  isOrders?: boolean
) => {
  const file = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const fileURL = URL.createObjectURL(file)
  const link = document.createElement('a')
  link.setAttribute('href', fileURL)
  let filename = `${reportType}_${totalCount}_${moment().format('YYYY_MM_DD')}.xlsx`
  if (filter && filter.fromDate && filter.toDate) {
  const fromDateFormatted = moment(filter.fromDate).format('YYYY_MM_DD');
  const toDateFormatted = moment(filter.toDate).format('YYYY_MM_DD');
    filename = `${reportType}_${totalCount}_${fromDateFormatted}_${toDateFormatted}.xlsx`
  } else {
    filename = fileName(reportType, totalCount, filter, isOrders)
  }
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(fileURL)
}

const fileName = (reportType: any, totalCount: any, filter: any, isOrders?: boolean) => {
  if (isOrders) {
    let filename = `${reportType}_${totalCount}_${filterFileName(filter)}_${moment().format(
      'YYYY_MM_DD'
    )}.xlsx`
    return filename
  }
  if (totalCount) {
    return `${reportType}_${totalCount}_${moment().format('YYYY_MM_DD')}.xlsx`
  }
  return `${reportType}_${moment().format('YYYY_MM_DD')}.xlsx`
}

const filterFileName = (filter: any) => {
  let selectedFilter = pick(filter, [
    'deliveryStatus',
    'financialStatus',
    'fulfillmentStatus',
    'orderType',
  ])
  const newFilter = Object.values(selectedFilter)

  const fileName = newFilter.map((element) => {
    return element ? element.toLowerCase() : element
  })
  return fileName.filter(Boolean).join('_')
}
